var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85921 5.51286C6.60657 5.25957 6.60627 4.84897 6.85921 4.59586L8.65413 2.80094L8.72932 2.73258C9.09123 2.43754 9.61438 2.43775 9.97639 2.73258L10.0516 2.80094L11.8465 4.59586L11.9295 4.69743C12.0958 4.94909 12.0679 5.29116 11.8465 5.51286C11.6248 5.73452 11.2828 5.76217 11.0311 5.59586L10.9295 5.51286L10.0018 4.58512L10.0018 8.44645C10.0017 8.80456 9.71147 9.09485 9.35335 9.09489C8.99519 9.09489 8.70499 8.80459 8.70491 8.44645L8.70491 4.58512L7.77718 5.51286L7.67464 5.59586C7.42289 5.762 7.0808 5.73445 6.85921 5.51286Z",
    fill: "#2BE66B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60521 4.85722C4.07606 5.37596 3.63154 5.98071 3.29429 6.64885C2.83121 7.56629 2.57037 8.60324 2.57037 9.70111C2.57037 13.4471 5.60713 16.4839 9.35317 16.4839C13.0992 16.4839 16.136 13.4471 16.136 9.70111C16.136 8.60324 15.8751 7.56629 15.412 6.64885C15.1231 6.07641 14.7554 5.55051 14.3232 5.08536",
    stroke: "#2BE66B",
    strokeWidth: 1.29719,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankUp);
export default __webpack_public_path__ + "static/media/rank-up.360d5e3fce22e3292ce8db5ed3c34eeb.svg";
export { ForwardRef as ReactComponent };